export const REQUEST_SERVICE_QUALTRICS_FORM_URL =
  'https://mable.qualtrics.com/jfe/form/SV_86NlaKRhys8PP4q?origin=platform';
